import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { forkJoin, Observable, Subscription } from 'rxjs';
import { EntityIconListPayloadModel, TrackerTabStateModel, EntityTrackPayloadModel } from 'src/app/model';
import { ZonesServiceService } from 'src/app/modules/plants/plant-details/zones/zones-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { DeletePopoverComponent } from './delete-popover/delete-popover.component';
import { FloorPlanService } from './service/floor-plan.service';
import { Traces } from './traces-model';
declare let Plotly: any;

@Component({
  selector: 'app-floor-plan',
  templateUrl: './floor-plan.component.html',
  styleUrls: ['./floor-plan.component.css']
})
export class FloorPlanComponent implements OnDestroy, OnInit {

  @ViewChild("myPlot", { static: true }) plotRef: ElementRef;

  @Input() pageType: string;

  @Input() state: TrackerTabStateModel;
  
  zoneNames = [];
  selectedZone = new FormControl('');
  showGraph: boolean = false;
  mappedEntities: any = [];
  availableEntities: any = [];
  toggleView: boolean = true;
  isAdd = false;
  applyMarker: boolean = false;
  editedEntityId: string;
  plotComplete: boolean = false;
  isview: boolean = false;
  viewToggle: boolean = false;

  private _searchKey: string = '';
  private _isCancel: boolean;
  private _deletedTrace: Traces;
  private _x: number;
  private _y: number;
  private _zoneData: any = [];
  private _traces = [];
  private _isEdit: boolean = false;
  private _entityIdList: string[] = [];
  private _siteData: any;
  private _alertsCount: any = [];
  private _lastSeenTimeList: any = [];
  private _dataServiceSubscription: Subscription;

  private _layout = {
    margin: {
      l: 50,
      r: 70,
      b: 20,
      t: 0
    },
    hoverlabel: {
      bgcolor: '#F7F7F5',
      font: { family: 'Roboto, "Helvetica Neue", sans-serif' }
    },
    images: [
      {
        source: "",
        xref: "x",
        yref: "y",
        x: 0,
        y: 5,
        sizex: 5,
        sizey: 5,
        sizing: "stretch",
        layer: "below",
      },
    ],
    xaxis: {
      range: [0, 5],
      showgrid: false,
      zeroline: false,
      visible: false,
    },
    yaxis: {
      range: [0, 5],
      showgrid: false,
      zeroline: false,
      visible: false,
    },
    hovermode: 'closest',
    dragmode: false,
    showlegend: false,
  };

  private _configurations = {
    responsive: true,
    displaylogo: false,
    scrollZoom: false,
    displayModeBar: false,
  };

  constructor(
    private _floorPlanService: FloorPlanService,
    private _zoneService: ZonesServiceService,
    private _serviceCallSerice: ServicecallService,
    private datePipe: DatePipe,
    private dataSer: DataService,
    public dialog: MatDialog
  ) {
    this._dataServiceSubscription = this.dataSer.events.subscribe((res: any) => {
      if (res.name === 'apiRefresh') {
        this.changeZone();
      } else if (res.name === 'siteChanged') {
        this._zoneChange();
      }
    });
  }

  ngOnInit(): void {
    this._zoneChange();
  }

  ngOnDestroy(): void {
    this._dataServiceSubscription?.unsubscribe();
  }

  /**
   * Zones change
   */
  private _zoneChange(): void {
    this.zoneNames = [];
    const reqData = {
      siteId: sessionStorage.getItem('siteId') ?
        JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
      classType: "normal",
      sortBy: {
        order: 1
      }
    };
    this._zoneService.getZonesData(reqData).subscribe({
      next: (result) => {
        if (result['status']) {
          this._zoneData = result['response']['data'];
          this._zoneData.forEach((elem: any) => {
            this.zoneNames.push({ name: elem.name, floorPlanImg: elem.floorPlan, id: elem._id });
          });
          this.selectedZone.setValue(
            this.state?.zoneId
              ? this.zoneNames?.find(value => value?.id === this.state?.zoneId)?.name
              : this.zoneNames?.[0]?.name
          );
          this.changeZone();
        }
      },
      error: (result) => {
        this._serviceCallSerice.toasterService({ type: 'success', msg: result[0]['response'].message });
      }
    })
  }

  /**
   * refreshes and sets all to null
   */
  changeZone() {
    let color: string;
    this.plotComplete = false;
    this._traces = [];
    this._entityIdList = [];
    this.mappedEntities = [];
    this.availableEntities = [];
    this._alertsCount = [];
    this.zoneNames.find(e => e.name === this.selectedZone.value).floorPlanImg ? this.showGraph = true : this.showGraph = false;
    this._layout.images[0].source = this.zoneNames.find(e => e.name === this.selectedZone.value).floorPlanImg;
    const zoneId = this.zoneNames.find(e => e.name === this.selectedZone.value).id;
    const payload = {
      siteId: sessionStorage.getItem('siteId') ?
        JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
      searchKey: this._searchKey
    };
    this._floorPlanService.getEntitydetails(payload).subscribe({
      next: (result) => {
        this._siteData = result;
        result?.forEach((elem: any) => {
          this._entityIdList?.push(elem?.entityId);
        });

        this._getLastActiveTime().subscribe(() => {
          this._siteData.map((elem: any) => {
            if (!elem?.available && elem?.zones?.[0] === zoneId) {
              const alertCount = this._alertsCount?.find(e => e?.entityId === elem?.entityId)?.alertCount ? this._alertsCount?.find(e => e?.entityId === elem?.entityId)?.alertCount : 0;
              const lastSeentime = this._lastSeenTimeList?.find(e => e?.entityId === elem?.entityId)?.time ? this._lastSeenTimeList?.find(e => e?.entityId === elem?.entityId)?.time : 'NA';
              alertCount > 0 ? color = '#ED604D' : color = '#16e053';
              const newTrace = new Traces(elem?.coordinates?.x, elem?.coordinates?.y, elem?.entityName, color, 15, elem?.entityId, alertCount, lastSeentime, elem?.uniqueId);
              this._traces.push(newTrace);
            }
          });
          result.map((elem: any) => {
            //lists entities with coordinates
            const alertCount = this._alertsCount.find(e => e.entityId === elem.entityId)?.alertCount ? this._alertsCount.find(e => e.entityId === elem.entityId).alertCount : 0;
            const lastSeentime = this._lastSeenTimeList.find(e => e.entityId === elem.entityId)?.time ? this._lastSeenTimeList.find(e => e.entityId === elem.entityId)?.time : 'NA';
            if (!elem?.available && elem?.zones?.[0] === zoneId) {
              this.mappedEntities.push({ name: elem?.entityName, entityId: elem?.entityId, mappingId: elem?.mappingId, alertCount: alertCount, lastSeentime: lastSeentime, uniqueId: elem?.uniqueId });
            } else if (elem?.available && !elem?.zones?.[0]) {
              this.availableEntities.push({ name: elem?.entityName, entityId: elem?.entityId, mappingId: elem?.mappingId, alertCount: alertCount, lastSeentime: lastSeentime, uniqueId: elem?.uniqueId });
            }
          });
          if (this.showGraph) {
            this._plotGraph(this._traces);
            if (this.state?.entityId && this.mappedEntities?.length) {
              this.viewMarker(this.mappedEntities?.findIndex(item => item?.entityId === this.state?.entityId), this.state?.entityId);
              this.state = {} as TrackerTabStateModel;
            }
          }
        });
      },
      error: (error) => {
        this._serviceCallSerice.toasterService({ type: 'error', msg: error });
      }
    })
  }

  /**
   * Plots graph
   * @param plotTraces 
   */
  private _plotGraph(plotTraces) {
    this.plotComplete = false;
    const plotElement = this.plotRef.nativeElement;
    Plotly.newPlot(plotElement, plotTraces, this._layout, this._configurations).then(chart => {
      this.plotComplete = true;
      document.addEventListener('click', (event) => {
        if (this.isAdd && !this.isview) {
          const target = event.target as HTMLElement;
          if (target.closest('.plotly')) {
            const e = event;
            const bgrect = document.getElementsByClassName('nsewdrag')[0].getBoundingClientRect();
            const x = ((e.x - bgrect['x']) / (bgrect['width'])) * (chart.layout.xaxis.range[1] - chart.layout.xaxis.range[0]) + chart.layout.xaxis.range[0];
            const y = ((e.y - bgrect['y']) / (bgrect['height'])) * (chart.layout.yaxis.range[0] - chart.layout.yaxis.range[1]) + chart.layout.yaxis.range[1];
            const index = plotTraces.length - 1
            if (index < chart?.data?.length) {
              Plotly.extendTraces(chart, {
                x: [[x]],
                y: [[y]]
              }, [index]);
              chart.data[index]?.x?.shift();
              chart.data[index]?.x?.splice(1, chart.data[index]?.x.length);
              chart.data[index]?.y?.shift();
              chart.data[index]?.y?.splice(1, chart.data[index]?.y.length);
              Plotly.redraw(plotElement);
              this._x = x;
              this._y = y;
              this.applyMarker = true;
            }
          }
        }
      });
    });
  }

  /**
   * Adds device
   * @param index 
   * @param id 
   */
  addDevice(index: number, id: string) {
    let color: string;
    this.applyMarker = false;
    this.editedEntityId = id;
    this.isAdd = true;
    this._entityIdList.push(id);
    this._getLastActiveTime().subscribe(() => {
      const alertCount = this._alertsCount.find(e => e.entityId === this.availableEntities[index].entityId)?.alertCount ? this._alertsCount.find(e => e.entityId === this.availableEntities[index].entityId).alertCount : 0;
      const lastSeentime = this._lastSeenTimeList.find(e => e?.entityId === this.availableEntities[index]?.entityId)?.time ? this._lastSeenTimeList.find(e => e.entityId === this.availableEntities[index].entityId)?.time : 'NA';
      alertCount > 0 ? color = '#ED604D' : color = '#16e053';
      const newTrace = new Traces(-100, 100, this.availableEntities?.[index]?.name, color, 15, this.availableEntities?.[index]?.entityId, alertCount, lastSeentime, this.availableEntities?.[index]?.uniqueId);
      this._traces.push(newTrace);
      this._plotGraph([newTrace]);
      let item = this.availableEntities.findIndex(item => item.entityId === id);
      if (item != -1) {
        this.mappedEntities.push(this.availableEntities[item]);
      }
    });
  }

  /**
   * Edits mapped device
   * @param editindex 
   * @param id 
   */
  editMappedDevice(editindex: number, id: string) {
    let color;
    this.editedEntityId = id;
    this.applyMarker = false;
    this.isAdd = true;
    this._entityIdList.push(id);
    this._getLastActiveTime().subscribe(() => {
      const alertCount = this._alertsCount.find(e => e.entityId === this.mappedEntities[editindex].entityId)?.alertCount ? this._alertsCount.find(e => e.entityId === this.mappedEntities[editindex].entityId).alertCount : 0;
      const lastSeentime = this._lastSeenTimeList.find(e => e?.entityId === this.mappedEntities[editindex]?.entityId)?.time ? this._lastSeenTimeList.find(e => e.entityId === this.mappedEntities[editindex].entityId)?.time : 'NA';
      alertCount > 0 ? color = '#ED604D' : color = '#16e053';
      const newTrace = new Traces(this._x, this._y, this.mappedEntities?.[editindex]?.name, color, 15, this.mappedEntities?.[editindex]?.entityId, alertCount, lastSeentime, this.mappedEntities?.[editindex]?.uniqueId);
      this._traces.push(newTrace);
      this._plotGraph([newTrace])
    });
  }

  /**
   * Deletes device
   * @param id 
   */
  deleteDevice(id: string) {
    const plotElement = this.plotRef.nativeElement;
    const index = this._traces.findIndex(trace => trace.entityId === id);
    this._deletedTrace = this._traces[index];
    //remove from traces
    if (index !== -1) {
      Plotly.deleteTraces(plotElement, index);
      this._x = this._deletedTrace.x[0];
      this._y = this._deletedTrace.y[0];
    }

    //remove from alerts array
    const arrIndex = this._entityIdList.indexOf(id);
    if (arrIndex > -1) {
      this._entityIdList.splice(arrIndex, 1);
    }
    const entityId = this.mappedEntities?.find(e => e?.entityId === id)?.entityId;

    if (!this._isEdit)
      this.mappedEntities = this.mappedEntities?.filter(e => e?.entityId !== entityId);

    const req = {
      entityId: [entityId],
      siteId: sessionStorage.getItem('siteId') ?
        JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
    }
    if (!this.isview) {
      this._floorPlanService.deleteEntityLocation(req).subscribe({
        next: (result) => {
          //checks if it is edit mode or not
          if (!this._isEdit)
            this._serviceCallSerice.toasterService({ type: 'success', msg: result?.message });
        },
        error: (result) => {
          //put toaster if error
        }
      });
    }
  }

  /**
   * Edits marker
   * @param point 
   * @param id 
   */
  editMarker(point: number, id: string) {
    this._isEdit = true;
    this.deleteDevice(id);
    this.editMappedDevice(point, id);
    this.editedEntityId = id;
  }

  /**
   * Views selected marker on floorplan
   * @param point 
   * @param id 
   */
  viewMarker(point: number, id: string) {
    this.viewToggle = !this.viewToggle;
    if (this.viewToggle) {
      this._isEdit = true;
      this.isview = true;
      this.deleteDevice(id);
      this.editMappedDevice(point, id);
      this.editedEntityId = id;
    } else {
      this.cancelEdit();
    }
  }

  /**
   * Updates entity coordinates
   */
  updateEntityCoordinates() {
    this._plotGraph(this._traces);
    this.isAdd = false;
    const mappingId = this.mappedEntities?.find(e => e?.entityId === this.editedEntityId)?.mappingId
    const req = {
      entityId: this.editedEntityId,
      mappingId: mappingId,
      coordinates: {
        x: this._x,
        y: this._y
      },
      zones: [this.zoneNames?.find(e => e?.name === this.selectedZone?.value)?.id]
    }
    if (!this.isview) {
      this._floorPlanService.updateEntityLocation(req).subscribe({
        next: (result) => {
          document.removeAllListeners();
          this._serviceCallSerice.toasterService({ type: 'success', msg: result?.message });
          if (!this._isEdit && !this._isCancel)
            this.toggle();
          this._isEdit = false;
          this._isCancel = false;
        },
        error: (result) => {
          this._serviceCallSerice.toasterService({ type: 'error', msg: result?.message });
        }
      });
    }

  }

  /**
   * Gets last active time
   * @returns last active time 
   */
  private _getLastActiveTime(): Observable<void> {
    return new Observable<void>((subscriber) => {
      this._lastSeenTimeList = [];
      let iconsData = [];
      const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
      const trackEntityPayload: Partial<EntityTrackPayloadModel> = {
        siteId: sessionStorage.getItem('siteId') ? JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
        from: this.datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZ'),
        to: this.datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZ'),
        entityIds: this._entityIdList,
        limit: 10000 //For no pagination
      };

      const payload: Partial<EntityIconListPayloadModel> = {
        entityId: this._entityIdList,
        from: this.datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZ'),
        to: this.datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZ')
      }
      forkJoin([
        this._serviceCallSerice.trackEntity(trackEntityPayload, 1),
        this._serviceCallSerice.iconList(payload)
      ]).subscribe({
        next: (result: any) => {
          if (result[0]['status']) {
            if (result[0]['response']['data'].length) {
              const entityData = [...result[0]['response']['data']].find((item: any) => Object.keys(item).includes('original'));
              const requiredData = entityData ? entityData.original : [];
              requiredData.forEach((elem: any) => {
                const time = this._serviceCallSerice.getLastSeenFormat(elem.sourceTimestamp);
                this._lastSeenTimeList.push({ time: time, entityId: elem.entityId });
              });
            }
          } else {
            this._lastSeenTimeList = [];
          }
          if (result[1]['status']) {
            iconsData = result[1]['response']['data'];
            iconsData.map((element) => {
              this._alertsCount.push({ entityId: element._id, alertCount: element.alertsCount })
            });
          } else {
            iconsData = [];
          }
          subscriber.next();
          subscriber.complete();
        },
        error: (result) => {
          this._serviceCallSerice.toasterService({ type: 'success', msg: result[0]['response'].message });
        }
      });
    });
  }

  /**
   * Toggles floor plan view
   */
  toggle() {
    this.toggleView = !this.toggleView;
    this.changeZone();
  }

  /**
   * Cancels edit
   */
  cancelEdit() {
    this._isCancel = true;
    this._traces.pop();
    this._traces.push(this._deletedTrace);
    this._x = this._deletedTrace.x[0];
    this._y = this._deletedTrace.y[0];
    this.updateEntityCoordinates();
    this.isview = false;
    this._plotGraph(this._traces);
    this.isAdd = false;
    this._isEdit = false;
  }

  /**
   * Cancels mapping
   */
  cancelMapping() {
    this._traces.pop();
    this._plotGraph(this._traces);
    this.isAdd = false;
    this._isEdit = false;
  }

  /**
   * Searchs on change
   * @param event 
   */
  searchOnChange(event) {
    this._searchKey = event;
    this.changeZone();
  }

  /**
   * Checks if delete
   * @param id 
   */
  checkIfDelete(id: string) {
    let dialogRef = this.dialog.open(DeletePopoverComponent, {
      data: { msg: "Are you sure you want to delete plotitng point?", type: null },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteDevice(id);
      }
    });
  }
}